// extracted by mini-css-extract-plugin
export var configurationSection = "_sh-0";